import { useContext } from "react"
import { Box, Skeleton } from "@mui/material"

import ButtonDesign from "./sections/ButtonDesign"
// import PageDesign from "./sections/PageDesign"
import FontDesign from "./sections/FontDesign"
import IconDesign from "./sections/IconDesign"
import { VibioThemeContext } from "../../../../context/VibioThemeProvider"

export default function Styling() {
    // The theme is seeded into the context by StudioPage from the loaded page; edits here persist
    // through saveThemeChange (read-modify-write). Customization is available on every tier — no
    // tier or subscription gating.
    const { theme } = useContext(VibioThemeContext)

    return (
        <>
            {theme === null || !theme ? (
                <Box sx={{ m: 0, display: "flex", flexDirection: "column", gap: "2rem" }}>
                    <Skeleton variant="rounded" height={90} />
                    <Skeleton variant="rounded" height={120} />
                    <Skeleton variant="rounded" height={100} />
                </Box>
            ) : (
                <>
                    {/* <PageDesign themeId={theme?.themeId} bgColor={theme?.bgColor} /> */}
                    <IconDesign themeId={theme?.themeId} iconColor={theme?.iconColor} />
                    <FontDesign themeId={theme?.themeId} fontStyle={theme?.fontStyle} />
                    <ButtonDesign
                        themeId={theme?.themeId}
                        btnColor={theme?.buttonColor}
                        btnStyleCode={theme?.buttonStyle}
                    />
                </>
            )}
        </>
    )
}
